import {IPosition, PositionResponseType} from "@/entity/position/position.types";

export default class Position implements IPosition {
    id: number;
    name: string;
    constructor(data: PositionResponseType) {
        this.id = data.id;
        this.name = data.name;
    }
}